import { render } from "./Feedback_message.vue?vue&type=template&id=2a4b1028&scoped=true"
import script from "./Feedback_message.vue?vue&type=script&lang=js"
export * from "./Feedback_message.vue?vue&type=script&lang=js"

import "./Feedback_message.vue?vue&type=style&index=0&id=2a4b1028&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4b1028"]])

export default __exports__